import React, { useState, useMemo, useCallback, FC, useEffect } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Link, useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faArrowsRotate, faChevronLeft, faChevronRight, faCog, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { PlatformDataType, PlatformProductMappingData } from 'src/interfaces/Platform.interface'
import { useAppDispatch, useAppSelector } from 'src/redux/storeHooks'
import { useRef } from 'react'
import { delistVariantsAsync, getAllPlatformTypesAsync, refreshPlatformDataAsync, } from 'src/redux/actions/platformActions'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'
import {
  getAllProductsVarientsFromChannelAsync, getAllProductsVarientsFromMainChannelAsync,
  linkProductVarientAsync, productVarientResyncAsync,
} from 'src/redux/actions/productActions'
import { deleteVariantAsync, deleteProductsAndVariantsBulkAsync } from 'src/redux/actions/omsProductActions'
import { getApiErrorMessage, isApiPayloadSuccess, KTIcon } from 'src/marketConnect/helpers'
import Button from 'react-bootstrap/Button'
import Dropdown from 'react-bootstrap/Dropdown'
import { Modal, Tab, Tabs } from 'react-bootstrap'
import CSVUploadModal from 'src/app/pages/listing/components/CSVUploadModal'
import ManoManoErrorReportUploadModal from 'src/app/pages/listing/components/ManoManoErrorReportUploadModal'
import CommonAlertModal from 'src/utils/modals/CommonAlertModal'
import { setProductTablePaginationData } from 'src/redux/slices/productSlice'
import useAppToast from 'src/hooks/useAppToast'
import Loader from 'src/utils/Loader'
import BulkProductLinking from 'src/app/pages/listing/components/BulkProductLinking'
import 'src/app/pages/listing/components/listing-products/Products.css'
import { loggedInAdminAccessToken } from 'src/utils/constants'
import { useUserHavingWriteAccess } from 'src/utils/useUserHavingWriteAccess'
import { usePermission } from 'src/hooks/usePermission'
import UploadCsvModal from 'src/app/pages/create-product/UploadCsvModal'
import GroupedTableProducts from 'src/app/pages/listing/components/listing-products/GroupedTableProducts'
import GroupedViewLiteContainer from './GroupedViewLiteContainer'
import {
  getListingProductBulkActionOptions,
  isListingProductBulkActionPlatform,
} from 'src/utils/listingProductBulkActions'
import { isListingProductUploadPlatform } from 'src/utils/listingProductUploadPlatforms'

//  New table system imports (from main) 
import { ProductTableLite } from 'src/app/features/listing-product-table-v2/ProductTableLite'
import { useTableColumns } from 'src/app/features/listing-product-table-v2/useTableColumns'
import { useTableData } from 'src/app/features/listing-product-table-v2/useTableData'
import { useTablePersistence } from 'src/app/features/listing-product-table-v2/useTablePersistence'
import { exportToCSV } from 'src/app/features/listing-product-table-v2/exportCSV'
import {
  SortState,
  FilterState,
  PaginationState,
  SelectedColumn,
} from 'src/app/features/listing-product-table-v2/types'
import { DEFAULT_PAGE_SIZE, DEFAULT_SORT_STATE, getDefaultColumnsFromLegacyRules } from 'src/app/features/listing-product-table-v2/defaultsFromLegacy'
import { isLinkingHubStore, shouldShowLinkingColumns } from 'src/app/features/listing-product-table-lite/linkingColumnVisibility'
import { isRowResyncEligible } from 'src/app/features/listing-product-table-lite/bundleStatusUtils'

const ProductsTable: FC = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate();
  const { isWrite } = usePermission();
  const { fetchedConnectedPlatformData } = useAppSelector((state) => state.fetchConnectedPlatform)
  const [showModal, setShowModal] = useState(false)
  const [mainStore, setMainStore] = useState(false)
  const [accountingStore, setAccountingStore] = useState(false)
  const [shippingStore, setShippingStore] = useState(false)
  const [erpStore, setErpStore] = useState(false)
  const [omsStore, setOmsStore] = useState(false)
  const [platformData, setPlatformData] = useState<PlatformDataType | null>(null)
  const [linkingCompleted, setLinkingCompleted] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [matchedParentProduct, setMatchedParentProduct] = useState<any | null>(null)
  const [clickedRowIndex, setClickedRowIndex] = useState<number | null>(null)
  const [showUploadModal, setShowUploadModal] = useState(false)
  const [showErrorReportUploadModal, setShowErrorReportUploadModal] = useState(false)
  const [showBulkProductLinkingModal, setShowBulkProductLinkingModal] = useState(false)
  const [platformModalId, setPlatformModalId] = useState<string>('')
  const [openConnectConfirmation, setOpenConnectConfirmation] = useState(false)
  const { connectedPlatformData } = useAppSelector((state) => state.connectedPlatform)
  const { successToast, errorToast } = useAppToast()
  const [paginationMainData, setPaginationMainData] = useState({
    page: 1,
    limit: 10,
    search_string: '',
  })
  const [showRefreshModal, setShowRefreshModal] = useState<boolean>(false)
  const [refreshPlatformId, setRefreshPlatformId] = useState<number | null>(null)
  const [refreshing, setRefreshing] = useState(false)
  const { id, platformId } = useParams()
  const [currentChannelData, setcurrentChannelData] = useState<PlatformProductMappingData | null>(null)
  const [tabsData, setTabsData] = useState([])
  const [activeTab, setActiveTab] = useState<any>(null)
  const [connectedPlatformsTypewise, setConnectedPlatformsTypewise] = useState<string[]>([]);
  const { fetchedUserAccountData } = useAppSelector((state) => state.userAccountData)

  /** Prefer `self_data` from the active channel (`/api/platform-typewise-list`) when ids match; fall back to connected-platform list. */
  const canShowCreateAndActions = useMemo(() => {
    const sd = currentChannelData?.self_data as PlatformDataType | undefined
    if (sd && id != null && id !== '') {
      const selfId = sd.id ?? (sd as { platform_id?: number }).platform_id
      if (selfId != null && Number(selfId) === Number(id)) {
        if (typeof sd.isOmsStore === 'boolean') {
          return sd.isOmsStore
        }
      }
    }
    const match = fetchedConnectedPlatformData?.find(
      (obj) => Number(obj.id) === Number(id)
    )
    return Boolean(match?.isOmsStore)
  }, [currentChannelData?.self_data, id, fetchedConnectedPlatformData])

  const isOmsPlatform = useMemo(() => {
    const selfData = currentChannelData?.self_data as any
    const matchedPlatform = (fetchedConnectedPlatformData || []).find(
      (item: any) => Number(item?.id) === Number(id)
    )
    const platformType = String(
      selfData?.type ||
      selfData?.platform_info?.type ||
      selfData?.platform_info?.nature ||
      matchedPlatform?.type ||
      matchedPlatform?.platform_info?.type ||
      matchedPlatform?.platform_info?.nature ||
      ''
    ).trim().toUpperCase()

    return Boolean(selfData?.isOmsStore || matchedPlatform?.isOmsStore || platformType === 'OMS')
  }, [currentChannelData?.self_data, fetchedConnectedPlatformData, id])

  const canShowUploadButton = useMemo(() => {
    const platformName = String(currentChannelData?.self_data?.name || '').trim().toUpperCase()
    const hasOmsTemplate =
      Array.isArray((currentChannelData as any)?.sample_product_files) &&
      (currentChannelData as any).sample_product_files.length > 0

    return isOmsPlatform || hasOmsTemplate || isListingProductUploadPlatform(platformName)
  }, [(currentChannelData as any)?.sample_product_files, currentChannelData?.self_data?.name, isOmsPlatform])

  const isManomanoPlatform =
    String(currentChannelData?.self_data?.name || '').trim().toUpperCase() === 'MANOMANO'

  const handleGroupedLiteEditProduct = useCallback(
    (row: any) => {
      if (!id) return
      navigate(`/update-product/platform/${Number(id)}/productId/${row?.id}`, {
        state: { mode: 'edit', rowData: row },
      })
    },
    [id, navigate]
  )

  const [activeView, setActiveView] = useState<'grouped' | 'flat' | 'grouped-lite'>('flat')
  const [clickedGroupedLiteRow, setClickedGroupedLiteRow] = useState<any | null>(null)

  // ========= NEW TABLE SYSTEM STATE (Lite)=========
  const { fetchedUserAccountData: liteUserData } = useAppSelector((state) => state.userAccountData)
  const liteUserId = liteUserData?.id
  const litePersistence = useTablePersistence({
    userId: liteUserId || 'guest',
    platformId: platformId || '0',
    channelId: id || '0',
  })
  const liteInitialState = litePersistence.getInitialState()
  const [liteSelectedColumns, setLiteSelectedColumns] = useState<SelectedColumn[]>(
    liteInitialState.selectedColumns || []
  )
  const [liteRouteInitialSelectedColumns, setLiteRouteInitialSelectedColumns] = useState<SelectedColumn[]>(
    liteInitialState.selectedColumns || []
  )
  const [liteColumnOrderCustomized, setLiteColumnOrderCustomized] = useState<boolean | undefined>(
    liteInitialState.columnOrderCustomized
  )
  const [liteSortState, setLiteSortState] = useState<SortState | null>(
    liteInitialState.sortState || null
  )
  const [liteFilterState, setLiteFilterState] = useState<FilterState>(
    liteInitialState.filterState || { globalSearch: '', columnFilters: [] }
  )
  const [litePaginationState, setLitePaginationState] = useState<PaginationState>({
    page: 1,
    pageSize: liteInitialState.pageSize || DEFAULT_PAGE_SIZE,
    total: 0,
    totalPages: 0,
  })
  const [liteSelectedItemForActions, setLiteSelectedItemForActions] = useState<Array<number | string>>([])
  const [liteSelectedAction, setLiteSelectedAction] = useState('')
  const [liteOpnDelistModal, setLiteOpnDelistModal] = useState(false)
  const [liteIsDelistIng, setLiteIsDelistIng] = useState(false)
  const [liteResyncingSelected, setLiteResyncingSelected] = useState(false)
  const [liteShowDeleteVariantModal, setLiteShowDeleteVariantModal] = useState(false)
  const [liteSelectedVariantToDelete, setLiteSelectedVariantToDelete] = useState<any>(null)
  const [liteIsDeletingVariant, setLiteIsDeletingVariant] = useState(false)
  // ---- bulk delete state ----
  const [liteShowBulkDeleteModal, setLiteShowBulkDeleteModal] = useState(false)
  const [litePreviewImageUrl, setLitePreviewImageUrl] = useState<string | null>(null)
  const [liteIsBulkDeleting, setLiteIsBulkDeleting] = useState(false)
  // ---------------------------
  const liteColumnsFetchInFlightRef = useRef<Promise<void> | null>(null)
  const liteInitializedCatalogRouteRef = useRef<string | null>(null)
  const liteHasInitialized = useRef(false)
  const liteRouteStateKey = `${platformId || '0'}:${id || '0'}`
  // ========= NEW TABLE SYSTEM STATE =========

  const liteAreSelectedColumnsEqual = useCallback(
    (a: SelectedColumn[], b: SelectedColumn[]) => {
      if (a === b) return true
      if (a.length !== b.length) return false
      for (let i = 0; i < a.length; i += 1) {
        const left = a[i]
        const right = b[i]
        if (
          left.field !== right.field ||
          left.order !== right.order ||
          left.width !== right.width ||
          (left.pinned || null) !== (right.pinned || null)
        ) {
          return false
        }
      }
      return true
    },
    []
  )

  // Route reset effect (Lite)
  useEffect(() => {
    const nextInitial = litePersistence.getInitialState()
    const routeInitialColumns = nextInitial.selectedColumns || []
    setLiteRouteInitialSelectedColumns(routeInitialColumns)
    setLiteColumnOrderCustomized(nextInitial.columnOrderCustomized)
    setLiteSelectedColumns(routeInitialColumns)
    setLiteSortState(nextInitial.sortState || DEFAULT_SORT_STATE)
    setLiteFilterState(nextInitial.filterState || { globalSearch: '', columnFilters: [] })
    setLitePaginationState({
      page: 1,
      pageSize: nextInitial.pageSize || DEFAULT_PAGE_SIZE,
      total: 0,
      totalPages: 0,
    })
    setLiteSelectedItemForActions([])
    setLiteSelectedAction('')
    setLiteResyncingSelected(false)
    liteColumnsFetchInFlightRef.current = null
    liteInitializedCatalogRouteRef.current = null
    liteHasInitialized.current = false
  }, [liteRouteStateKey])

  // Mark as initialized after each route hydration (Lite)
  useEffect(() => {
    litePersistence.markInitialized()

  }, [platformId, id])

  // ========= NEW TABLE HOOKS =========
  const isTiktokPlatformLite = ((currentChannelData?.self_data?.name || '') as string).toUpperCase() === 'TIKTOK'
  const isLightspeedPlatformLite = ((currentChannelData?.self_data?.name || currentChannelData?.self_data?.code || '') as string).toUpperCase() === 'LIGHTSPEED'
  const isFairePlatformLite = ((currentChannelData?.self_data?.name || '') as string).toUpperCase() === 'FAIRE'
  const isWalmartPlatformLite = ((currentChannelData?.self_data?.name || '') as string).toUpperCase() === 'WALMART'
  const showLinkingColumns = shouldShowLinkingColumns({
    mainStore,
    accountingStore,
    shippingStore,
    erpStore,
    omsStore,
    tabsData,
  })
  const liteMandatoryColumns = useMemo(
    () =>
      showLinkingColumns
        ? ['name', 'linking_status', 'link_actions']
        : ['name'],
    [showLinkingColumns]
  )
  const liteDefaultColumnOptions = useMemo(
    () => ({
      mainStore,
      accountingStore,
      shippingStore,
      erpStore,
      omsStore,
      hasLinkingColumns: showLinkingColumns,
      isTiktokPlatform: isTiktokPlatformLite,
      isFairePlatform: isFairePlatformLite,
      isLightspeedPlatform: isLightspeedPlatformLite,
      isWalmartPlatform: isWalmartPlatformLite,
      tabsData: tabsData || [],
    }),
    [mainStore, accountingStore, shippingStore, erpStore, omsStore, showLinkingColumns, isTiktokPlatformLite, isFairePlatformLite, isLightspeedPlatformLite, isWalmartPlatformLite, tabsData]
  )
  const {
    data: liteData,
    total: liteTotal,
    totalPages: liteTotalPages,
    loading: liteDataLoading,
    error: liteDataError,
    responseColumns: liteResponseColumns,
    refetch: liteRefetch,
  } = useTableData({
    channelId: id || '0',
    page: litePaginationState.page,
    pageSize: litePaginationState.pageSize,
    globalSearch: liteFilterState.globalSearch,
    columnFilters: liteFilterState.columnFilters,
    sortState: liteSortState,
    selectedColumns: liteSelectedColumns,
    enabled: activeView === 'flat',
  })
  const {
    catalogColumns: liteCatalogColumns,
    selectedColumns: liteManagedColumns,
    updateSelectedColumns: liteUpdateSelectedColumns,
    reorderColumns: liteReorderColumns,
    pinColumn: litePinColumn,
    getColumnByField: liteGetColumnByField,
    loading: liteColumnsLoading,
    error: liteColumnsError,
    refetch: liteRefetchColumns,
  } = useTableColumns({
    channelId: id || '0',
    initialSelectedColumns: liteRouteInitialSelectedColumns,
    isPrimaryStore: mainStore,
    defaultColumnOptions: liteDefaultColumnOptions,
    useApiColumnOrder: true,
    initialColumnOrderCustomized: liteColumnOrderCustomized,
    onColumnOrderCustomizedChange: setLiteColumnOrderCustomized,
    mandatoryFields: liteMandatoryColumns,
    bootstrapColumns: liteResponseColumns,
    autoFetchCatalog: false,
  })

  const liteIsSecondaryOnlyField = useCallback((field?: string) => {
    return field === 'linking_status' || field === 'link_actions'
  }, [])

  const liteIsTruthyFlag = useCallback((value: any) => {
    if (value === true) return true
    if (typeof value === 'number') return value === 1
    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase()
      return normalized === 'true' || normalized === 'yes' || normalized === '1'
    }
    return false
  }, [])

  const liteIsDefaultVisibleColumn = useCallback((col: any) => {
    if (!col) return false
    const advance = col?.advance_option || {}
    return (
      col?.allowVisibility === 'ALWAYS_VISIBLE' ||
      col?.allow_visiblity === 'ALWAYS_VISIBLE' ||
      col?.allow_visibility === 'ALWAYS_VISIBLE' ||
      Boolean(col?.fixed) ||
      liteIsTruthyFlag(col?.default_visible) ||
      liteIsTruthyFlag(col?.is_default) ||
      liteIsTruthyFlag(col?.default) ||
      liteIsTruthyFlag(advance?.default_visible) ||
      liteIsTruthyFlag(advance?.is_default) ||
      liteIsTruthyFlag(advance?.default)
    )
  }, [liteIsTruthyFlag])

  const liteDefaultVisibleFields = useMemo(() => {
    const normalizeApiField = (field?: string) => {
      if (!field) return ''
      if (field === 'link_action') return 'link_actions'
      return field
    }

    const normalized = (liteCatalogColumns || [])
      .map((col: any) => {
        const field = normalizeApiField(col?.field || col?.id || '')
        if (!field) return null
        const visibility = col?.allowVisibility || col?.allow_visiblity || col?.allow_visibility || 'YES'
        if (visibility === 'NO') return null
        if (!showLinkingColumns && liteIsSecondaryOnlyField(field)) return null
        return { field, col }
      })
      .filter((item): item is { field: string; col: any } => Boolean(item?.field))

    const apiDefaultFields = normalized
      .filter((item) => liteIsDefaultVisibleColumn(item.col))
      .map((item) => item.field)

    const legacyDefaultFields = getDefaultColumnsFromLegacyRules({
      ...liteDefaultColumnOptions,
      mainStore,
      hasLinkingColumns: showLinkingColumns,
    })
      .map((c) => c.field)
      .filter((field) => normalized.some((item) => item.field === field))
      .filter((field) => !(!showLinkingColumns && liteIsSecondaryOnlyField(field)))

    const apiDefaultRemainder = apiDefaultFields.filter((field) => !legacyDefaultFields.includes(field))
    const finalFields = (
      legacyDefaultFields.length > 0
        ? [...legacyDefaultFields, ...apiDefaultRemainder]
        : apiDefaultFields.length > 0
          ? apiDefaultFields
          : normalized.map((item) => item.field)
    )
      .filter((field, index, arr) => arr.indexOf(field) === index)

    return finalFields
  }, [liteCatalogColumns, liteIsSecondaryOnlyField, liteIsDefaultVisibleColumn, liteDefaultColumnOptions, showLinkingColumns])

  const liteEnsureFieldsVisible = useCallback(
    (columns: SelectedColumn[], fields: string[]) => {
      const normalizedFields = Array.from(new Set(fields.filter(Boolean)))
      if (!normalizedFields.length) return columns

      const existingFields = new Set(columns.map((col) => col.field))
      let maxOrder = columns.length > 0 ? Math.max(...columns.map((col) => col.order)) : -1
      const next = [...columns]

      normalizedFields.forEach((field) => {
        if (existingFields.has(field)) return
        maxOrder += 1
        const catalogColumn = liteCatalogColumns.find((col) => col.field === field)
        next.push({
          field,
          order: maxOrder,
          width: catalogColumn?.width,
          pinned: null,
        })
      })

      return next.map((col, idx) => ({ ...col, order: idx }))
    },
    [liteCatalogColumns]
  )

  // Catalog refetch trigger effect (Lite)
  useEffect(() => {
    if (activeView !== 'flat') return
    if (!id) return
    if (!currentChannelData?.self_data) return
    const currentMetaId = String(
      (currentChannelData as any)?.self_data?.id ??
      (currentChannelData as any)?.self_data?.platform_id ??
      ''
    )
    if (!currentMetaId || currentMetaId !== String(id)) return
    const hasLinkingContext = showLinkingColumns
    const catalogRouteKey = `${liteRouteStateKey}:${hasLinkingContext ? 'link' : 'nolink'}`
    if (liteInitializedCatalogRouteRef.current === catalogRouteKey) return
    liteInitializedCatalogRouteRef.current = catalogRouteKey
    Promise.resolve(liteRefetchColumns({ syncSelection: true }) as any).catch(() => { })
  }, [activeView, liteRouteStateKey, id, currentChannelData?.self_data, showLinkingColumns, liteRefetchColumns])

  // Managed columns sync effect (Lite)
  useEffect(() => {
    if (liteManagedColumns.length > 0 && !liteHasInitialized.current) {
      setLiteSelectedColumns((prev) =>
        liteAreSelectedColumnsEqual(prev, liteManagedColumns) ? prev : liteManagedColumns
      )
      liteHasInitialized.current = true
    }
    if (liteHasInitialized.current && liteManagedColumns.length > 0) {
      setLiteSelectedColumns((prev) =>
        liteAreSelectedColumnsEqual(prev, liteManagedColumns) ? prev : liteManagedColumns
      )
    }
  }, [liteManagedColumns, liteAreSelectedColumnsEqual])

  useEffect(() => {
    if (!isLinkingHubStore({ mainStore, omsStore }) || !showLinkingColumns) return
    if (!liteCatalogColumns.length) return

    const requiredFields = ['name', 'linking_status', 'link_actions']
    const nextColumns = liteEnsureFieldsVisible(liteSelectedColumns, requiredFields)

    if (liteAreSelectedColumnsEqual(liteSelectedColumns, nextColumns)) return

    setLiteSelectedColumns(nextColumns)
    liteUpdateSelectedColumns(nextColumns)
  }, [
    mainStore,
    omsStore,
    showLinkingColumns,
    liteCatalogColumns,
    liteSelectedColumns,
    liteEnsureFieldsVisible,
    liteAreSelectedColumnsEqual,
    liteUpdateSelectedColumns,
  ])

  // Pagination total sync effect (Lite)
  useEffect(() => {
    setLitePaginationState((prev) => ({
      ...prev,
      total: liteTotal,
      totalPages: liteTotalPages,
    }))
  }, [liteTotal, liteTotalPages])

  // Persistence save effect (Lite)
  useEffect(() => {
    if (litePersistence.isInitialized()) {
      litePersistence.savePersistedState({
        selectedColumns: liteSelectedColumns,
        columnOrderCustomized: liteColumnOrderCustomized,
        sortState: liteSortState,
        filterState: liteFilterState,
        pageSize: litePaginationState.pageSize,
      })
    }
  }, [liteSelectedColumns, liteColumnOrderCustomized, liteSortState, liteFilterState, litePaginationState.pageSize])

  // ========= new table handlers
  const isFlatOmsStore = canShowCreateAndActions

  const liteCatalogColumnsWithActions = useMemo(() => {
    if (!isFlatOmsStore) return liteCatalogColumns
    if (liteCatalogColumns.some(c => c.field === 'flat_lite_actions')) return liteCatalogColumns
    return [
      ...liteCatalogColumns,
      {
        id: 'flat-lite-actions',
        name: 'Actions',
        field: 'flat_lite_actions',
        label: 'Actions',
        headerName: 'Actions',
        sortable: false,
        filterable: false,
        resizable: false,
        filterInputType: 'TEXT',
        filterOptions: [],
        filterOperators: [],
        allowVisibility: 'ALWAYS_VISIBLE',
        allow_visiblity: 'ALWAYS_VISIBLE',
        fixed: false,
        type: 'custom',
        width: 130,
      } as any
    ]
  }, [liteCatalogColumns, isFlatOmsStore])

  const liteSelectedColumnsWithActions = useMemo(() => {
    if (!isFlatOmsStore) return liteSelectedColumns
    if (liteSelectedColumns.some(c => c.field === 'flat_lite_actions')) return liteSelectedColumns

    const next = [...liteSelectedColumns]
    next.push({
      field: 'flat_lite_actions',
      order: next.length,
      pinned: null
    } as any)
    return next
  }, [liteSelectedColumns, isFlatOmsStore])

  const liteGetColumnByFieldWithActions = useCallback((field: string) => {
    return liteCatalogColumnsWithActions.find((c: any) => c.field === field)
  }, [liteCatalogColumnsWithActions])

  const handleFlatLiteEditVariant = useCallback((row: any) => {
    if (!id) return
    const editVariantId = row?.id
    const editProductId = row?.platform_product?.id || row?.product_id
    if (editVariantId && editProductId) {
      if (row?.has_options === false || row?.platform_product?.has_options === false) {
        navigate(`/update-product/platform/${Number(id)}/productId/${editProductId}`, {
          state: {
            mode: 'edit',
            rowData: row,
            platformId: Number(id),
          },
        })
      } else {
        navigate(
          `/update-variant/platform/${Number(id)}/productId/${editProductId}/variantId/${editVariantId}`,
          {
            state: {
              mode: 'edit',
              editProductId,
              editVariantId,
            },
          }
        )
      }
    } else {
      errorToast("Unable to edit variant: missing product or variant reference")
    }
  }, [id, navigate, errorToast])

  const handleFlatLiteDeleteVariant = useCallback((row: any) => {
    setLiteSelectedVariantToDelete(row)
    setLiteShowDeleteVariantModal(true)
  }, [])

  // ---- OMS Commercium: enable multi-select + bulk delete ----
  // Same gate as the edit/delete action column: OMS store + write permission
  const liteEnableDeleteSelection = canShowCreateAndActions && isWrite

  const handleBulkDeleteClick = useCallback(() => {
    setLiteShowBulkDeleteModal(true)
  }, [])

  const handleBulkDeleteConfirm = async () => {
    if (!liteSelectedItemForActions.length) return

    const variantIds = liteSelectedItemForActions.map(Number)

    try {
      setLiteIsBulkDeleting(true)
      const res: any = await dispatch(
        deleteProductsAndVariantsBulkAsync({
          product_ids: [],
          variant_ids: variantIds,
        })
      ).unwrap()

      successToast(res?.message || `${variantIds.length} variant(s) deleted successfully`)
      setLiteShowBulkDeleteModal(false)
      setLiteSelectedItemForActions([])
      liteRefetch()
    } catch (error: any) {
      errorToast(
        error?.data?.message || error?.data?.errors?.detail || error?.message || 'Bulk delete failed'
      )
    } finally {
      setLiteIsBulkDeleting(false)
    }
  }
  // -----------------------------------------------------------

  const handleDeleteVariantConfirm = async () => {
    if (!liteSelectedVariantToDelete) return
    const editProductId = liteSelectedVariantToDelete?.platform_product?.id || liteSelectedVariantToDelete?.product_id
    if (!editProductId) {
      errorToast('Unable to delete variant: missing product reference')
      return
    }
    try {
      setLiteIsDeletingVariant(true)
      const res: any = await dispatch(
        deleteVariantAsync({
          productId: editProductId,
          variantId: liteSelectedVariantToDelete.id,
        })
      ).unwrap()

      const status = Number(res?.status)
      if (status === 200 || status === 201) {
        successToast(res?.message || 'Variant deleted successfully')
        setLiteShowDeleteVariantModal(false)
        setLiteSelectedVariantToDelete(null)
        liteRefetch()
      } else {
        errorToast(
          res?.message || res?.data?.message || res?.errors?.detail || 'Failed to delete variant'
        )
      }
    } catch (error: any) {
      errorToast(
        error?.data?.message || error?.data?.errors?.detail || error?.message || 'Delete failed'
      )
      console.error('Variant delete failed:', error)
    } finally {
      setLiteIsDeletingVariant(false)
    }
  }

  const liteHandleColumnsChange = useCallback(
    (columns: SelectedColumn[]) => {
      const cleanColumns = columns.filter((c) => c.field !== 'flat_lite_actions')
      setLiteSelectedColumns((prev) => (liteAreSelectedColumnsEqual(prev, cleanColumns) ? prev : cleanColumns))
      liteUpdateSelectedColumns(cleanColumns)
    },
    [liteUpdateSelectedColumns, liteAreSelectedColumnsEqual]
  )

  const liteHandleReorderColumns = useCallback(
    (dragIndex: number, hoverIndex: number) => {
      setLiteColumnOrderCustomized(true)
      liteReorderColumns(dragIndex, hoverIndex)
    },
    [liteReorderColumns]
  )

  const liteHandlePinColumn = useCallback(
    (field: string, position: 'left' | 'right' | null) => {
      litePinColumn(field, position)
      setLiteSelectedColumns((prev) =>
        prev.map((col) => (col.field === field ? { ...col, pinned: position } : col))
      )
    },
    [litePinColumn]
  )

  const liteHandleSortChange = useCallback((field: string, direction: 'asc' | 'desc') => {
    setLiteSortState({ field, direction })
    setLitePaginationState((prev) => ({ ...prev, page: 1 }))
  }, [])

  const liteHandleFilterChange = useCallback((filters: FilterState) => {
    setLiteFilterState(filters)
    setLitePaginationState((prev) => ({ ...prev, page: 1 }))
  }, [])

  const liteHandlePageChange = useCallback((page: number) => {
    setLitePaginationState((prev) => ({ ...prev, page }))
  }, [])

  const liteHandlePageSizeChange = useCallback((pageSize: number) => {
    setLitePaginationState((prev) => ({ ...prev, pageSize, page: 1 }))
  }, [])

  const liteHandleExportCSV = useCallback(() => {
    exportToCSV(liteData, liteSelectedColumnsWithActions, liteGetColumnByFieldWithActions as any, id || '0', tabsData)
  }, [liteData, liteSelectedColumnsWithActions, liteGetColumnByFieldWithActions, id, tabsData])

  const liteHandleOpenColumnsConfig = useCallback(async () => {
    if (liteColumnsFetchInFlightRef.current) {
      await liteColumnsFetchInFlightRef.current
      return
    }
    const pending = Promise.resolve(liteRefetchColumns({ syncSelection: false }) as any).then(() => { })
    liteColumnsFetchInFlightRef.current = pending
    try {
      await pending
    } finally {
      liteColumnsFetchInFlightRef.current = null
    }
  }, [liteRefetchColumns])

  const liteHandleResyncClick = useCallback((rowData: any) => {
    if (!rowData?.id) return
    dispatch(productVarientResyncAsync({ failed_variant_ids: [Number(rowData.id)] }) as any)
      .then(() => {
        successToast('Failed Product resyncing started, status changed to Pending')
        liteRefetch()
      })
      .catch(() => {
        errorToast('Order resync failed. Please try again.')
      })
  }, [dispatch, successToast, errorToast, liteRefetch])

  const liteHandleResetColumns = useCallback(() => {
    setLiteSortState(DEFAULT_SORT_STATE)
    setLiteFilterState({ globalSearch: '', columnFilters: [] })
    setLitePaginationState((prev) => ({ ...prev, page: 1 }))
    liteRefetch()
  }, [liteRefetch])

  const { isUserHavingWriteAccess } = useUserHavingWriteAccess()

  const litePlatformName = (currentChannelData?.self_data?.name || '').toUpperCase()
  const liteBulkActionOptions = useMemo(
    () => getListingProductBulkActionOptions(litePlatformName),
    [litePlatformName]
  )
  const liteAllowedBulkActions = useMemo(
    () => new Set(liteBulkActionOptions.map((option) => option.value)),
    [liteBulkActionOptions]
  )

  const liteEnableBulkActions =
    isWrite &&
    !mainStore &&
    !erpStore &&
    isUserHavingWriteAccess() &&
    isListingProductBulkActionPlatform(litePlatformName)

  const liteEnableResyncSelection =
    isWrite &&
    !mainStore &&
    isUserHavingWriteAccess()

  const liteSelectedFailedVariantIds = useMemo(() => {
    if (!liteEnableResyncSelection) return []
    const selectedIds = new Set((liteSelectedItemForActions || []).map((itemId) => String(itemId)))
    return (liteData || [])
      .filter((row: any) => selectedIds.has(String(row?.id)) && isRowResyncEligible(row))
      .map((row: any) => Number(row.id))
      .filter((rowId: number) => Number.isFinite(rowId))
  }, [liteData, liteEnableResyncSelection, liteSelectedItemForActions])

  const liteHandleResyncSelected = useCallback(() => {
    if (!liteSelectedFailedVariantIds.length) return
    setLiteResyncingSelected(true)
    dispatch(productVarientResyncAsync({ failed_variant_ids: liteSelectedFailedVariantIds }) as any)
      .then(() => {
        successToast('Failed Product resyncing started, status changed to Pending')
        setLiteSelectedItemForActions([])
        liteRefetch()
      })
      .catch(() => {
        errorToast('Product resync failed. Please try again.')
      })
      .finally(() => {
        setLiteResyncingSelected(false)
      })
  }, [dispatch, errorToast, liteRefetch, liteSelectedFailedVariantIds, successToast])

  const liteHandleBulkActionChange = useCallback(
    (action: string) => {
      if (action && !liteAllowedBulkActions.has(action)) return
      setLiteSelectedAction(action)
      if (action === 'delist' || action === 'relist' || action === 'full_update') {
        setLiteOpnDelistModal(true)
      } else {
        setLiteOpnDelistModal(false)
      }
    },
    [liteAllowedBulkActions]
  )
  // ============== end of new table handlers

  const handleCreate = () => {
    navigate("/create-product", { state: { mode: "create", rowData: undefined, platformId: Number(id) } });
  };

  const productVariantSlice = useAppSelector((state) => state.productVarientsOfSingleChannel)

  const { productTablePaginationData } = useAppSelector(
    (state) => state.productsOfSingleChannel
  )

  const productVarientsFromMainChannel = useAppSelector((state) => state.productVarientFromMain)
  const { connectedPlatformTypes } = useAppSelector(
    (state) => state.fetchConnectedPlatform
  )
  // const {mainStoreData, accountingStoreData} = useAppSelector((state) => state.fetchConnectedPlatform)
  // const accountingStoreId = useAppSelector((state) => state.fetchConnectedPlatform.accountingStoreData?.id)
  //   const shippingStoreId = useAppSelector((state) => state.fetchConnectedPlatform.shippingStoreData?.id)

  useEffect(() => {
    dispatch(
      setProductTablePaginationData({
        page: 1,
        sync_status: '',
        search_string: '',
        accounting_sync_status: '',
        shipping_sync_status: '',
        erp_sync_status: '',
        erp_secondary_sync_status: '',
      })
    )
  }, [id, platformId, dispatch])

  useEffect(() => {
    dispatch(getAllPlatformTypesAsync({ platform_id: id! })).then((res: any) => {
      const { data, self_data } = res?.payload
      const main = Boolean(self_data?.isMainStore)
      const accounting = Boolean(self_data?.isAccountingStore)
      const shipping = Boolean(self_data?.isShippingStore)
      const erp = Boolean(self_data?.isErpStore)
      const oms = Boolean(self_data?.isOmsStore)

      setMainStore(main)
      setAccountingStore(accounting)
      setShippingStore(shipping)
      setErpStore(erp)
      setOmsStore(oms)

      setTabsData(data)
      setcurrentChannelData(res?.payload)
      if (res?.payload?.data?.length > 0) {
        setActiveTab(res.payload.data[0].id)
      }

      const platformTypes = Array.isArray(data) ? data.map((item) => item.name) : [];
      setConnectedPlatformsTypewise(platformTypes)
    })
  }, [id])

  // Legacy fetch for old flat view removed to reduce latency (replaced by ProductTableLite)

  useEffect(() => {
    if (!showModal || !activeTab) {
      return
    }
    try {
      dispatch(getAllProductsVarientsFromMainChannelAsync({ id: String(activeTab), paginationdata: paginationMainData, }))
    } catch (err) {
      console.error('Error fetching platform data:', err)
    }
  }, [showModal, activeTab, paginationMainData])

  const handlePagination = (pageNumber) => {
    setPaginationMainData((pre) => {
      return { ...pre, page: pageNumber }
    })
  }

  // ProductTableLite / GroupedViewLiteContainer pass the row via clickedGroupedLiteRow;
  const clickedProductVariant: any = clickedGroupedLiteRow ?? (clickedRowIndex !== null && clickedRowIndex >= 0 &&
    clickedRowIndex < productVariantSlice.productVarientsOfSingleChannel.length
    ? productVariantSlice.productVarientsOfSingleChannel[clickedRowIndex] : null)

  const { name, sku, platform_product: { name: platformProductName = '', image_set: [productImage] = [] } = {},
  } = clickedProductVariant || {}

  const handleClose = () => {
    setShowModal(false)
    setMatchedParentProduct(null) // Reset matched product details when modal is closed
    setSearchTerm('')
    setOpenConnectConfirmation(false)
    setClickedGroupedLiteRow(null)
    setClickedRowIndex(null)
    setPaginationMainData({
      limit: 10,
      page: 1,
      search_string: '',
    })
  }

  const handleLinkProductVariant = (activeTab) => {
    if (!clickedProductVariant?.id) {
      return
    }

    const selectedChannel: any = tabsData.find((item: any) => item.id === Number(activeTab))
    const channelType = String(selectedChannel?.type || '').toLowerCase()

    if (!matchedParentProduct?.id) {
      errorToast('Please select a product before linking.')
      return
    }

    setLinkingCompleted(true) // Set linking completion state to true

    const selected_channel_key: Record<string, string> = {
      primary: 'parent_variant_id',
      oms: 'oms_parent_variant_id',
      accounting: 'accounting_parent_variant_id',
      shipping: 'shipping_parent_variant_id',
      erp: 'erp_parent_variant_id',
      erp_secondary: 'erp_secondary_parent_variant_id',
    }
    const payload: any = {
      variant_id: clickedProductVariant?.id,
    };

    const key = selected_channel_key[channelType];

    if (key && matchedParentProduct?.id) {
      payload[key] = matchedParentProduct.id;
    }

    dispatch(
      linkProductVarientAsync(payload)
    ).then((response: any) => {
      const successMessage = response?.payload?.message || response?.payload?.data?.message
      const errorMessage =
        response?.payload?.data?.message ||
        response?.payload?.data?.error ||
        response?.payload?.message

      if (linkProductVarientAsync.fulfilled.match(response)) {
        toast.success(successMessage || 'Product Listing Linked Successfully')
        handleClose() // Close the modal
        liteRefetch() // Refresh flat view data
        return
      }

      errorToast(errorMessage || 'Failed to link product')
    })
      .catch(() => {
        errorToast('Failed to link product')
      })
      .finally(() => {
        setLinkingCompleted(false)
      })
  }

  // Removed redundant legacy variant fetcher


  // Function to open the CSV upload modal
  const handleOpenUploadModal = () => {
    setShowUploadModal(true)
    setPlatformData(currentChannelData?.self_data);
    if (id) {
      setPlatformModalId(id)
    }
  }

  const handleCloseUploadModal = () => {
    setShowUploadModal(false)
  }

  const handleOpenErrorReportUploadModal = () => {
    setShowErrorReportUploadModal(true)
    setPlatformData(currentChannelData?.self_data)
    if (id) {
      setPlatformModalId(id)
    }
  }

  const handleCloseErrorReportUploadModal = () => {
    setShowErrorReportUploadModal(false)
  }

  const handleOpenBulkProductLinkingModal = () => {
    setShowBulkProductLinkingModal(true)

    if (id) {
      setPlatformModalId(id)
    }
  }

  const handleCloseBulkProductLinkingModal = () => {
    setShowBulkProductLinkingModal(false)
  }

  const calculateVisibleRecordRange = ({ page, limit }) => {
    const count = productVarientsFromMainChannel.ProductVarientCountFromMainChannel
    const startRecord = (page - 1) * limit + 1;
    const endRecord = Math.min(page * limit, count);
    return { startRecord, endRecord };
  };
  // Product Record range for each paginated section
  const productRecordRange = calculateVisibleRecordRange(paginationMainData);

  return (
    <>
      {currentChannelData?.self_data?.id === Number(id) && (
        <>
          <div className='product-table-container  mb-3'>
            <div className='d-flex flex-row flex-wrap justify-content-between mb-3'>
              <div className='d-flex flex-row flex-wrap'>
                <div className='d-flex align-items-center'>
                  <span className='fw-bold text-lg' style={{ fontSize: '16px' }}>
                    {mainStore
                      ? 'Source Store Product'
                      : isOmsPlatform
                        ? 'Master Products'
                        : erpStore
                          ? 'ERP Store Product'
                          : accountingStore
                            ? 'Accounting Store Product'
                            : shippingStore
                              ? 'Shipping Store Product'
                              : omsStore
                                ? 'Master Products'
                                : 'Destination Store Product'}
                  </span>
                  <span className='ms-2 fw-bold text-lg' style={{ fontSize: '16px' }}>
                    - {((name) => {
                      if (!name) return '';
                      return name.toUpperCase() === 'COMMERCIUMOMS' ? 'Commercium OMS' : name;
                    })(currentChannelData?.self_data?.display_name || currentChannelData?.self_data?.name)}
                  </span>
                </div>
              </div>
              <div>
                {/* <div className='ms-2  pe-2 mb-3'>
              {displayName === 'The Range' && (
                <button
                  className='btn  me-4 ms-10 btn-primary btn-sm d-inline-flex'
                  onClick={handleOpenUploadModal}
                >
                  <div className='me-2' style={{fontSize: '14px'}}>
                    <FontAwesomeIcon icon={faFile} className='svg-icon-muted svg-icon-2hx' />
                  </div>
                  <div style={{fontSize: '14px'}}>Upload Product List</div>
                </button>
              )}

              <button
                className='btn btn-primary btn-sm d-inline-flex'
                onClick={handleOpenSettingsModal}
              >
                <div className='mt-1 me-2'>
                  <FontAwesomeIcon
                    icon={faCog}
                    className='svg-icon-muted svg-icon-2hx'
                    style={{fontSize: '14px'}}
                  />
                </div>
                <div style={{fontSize: '14px'}}>Settings</div>
              </button>
            </div> */}
                <div className='d-flex justify-content-sm-end ms-2 pe-2 mb-3 mt-2'>
                  {/* {currentChannelData?.is_product_mapping_allowed && 
              ( fetchedUserAccountData?.role &&  fetchedUserAccountData?.role?.customer_access === "WRITE" || (fetchedUserAccountData?.is_superuser || fetchedUserAccountData?.user_type ==="USER")) 
               */}
                  {/* {currentChannelData?.is_product_mapping_allowed && (
  fetchedUserAccountData?.role
    ? fetchedUserAccountData?.role?.customer_access === "WRITE"
    : fetchedUserAccountData?.is_superuser || fetchedUserAccountData?.user_type ==="USER"
)  */}
                  {(isWrite && currentChannelData?.is_product_mapping_allowed && isUserHavingWriteAccess()) && (
                    <button
                      className='btn btn-primary btn-sm d-inline-flex align-items-center me-2'
                      onClick={handleOpenBulkProductLinkingModal}
                      style={{ fontSize: '14px', padding: '0.25rem 0.5rem', height: '34px' }}
                    // disabled={fetchedUserAccountData?.role?.customer_access === "READ"}
                    >
                      <div className='me-2' style={{ fontSize: '14px' }}>
                        <i className='bi bi-file-earmark-arrow-up fs-4'></i>
                      </div>
                      <div style={{ fontSize: '14px' }}>Bulk Product Linking</div>
                    </button>
                  )}

                  {canShowUploadButton &&
                    !isOmsPlatform &&
                    isWrite && isUserHavingWriteAccess() && (
                      <button
                        className='btn btn-primary btn-sm d-inline-flex align-items-center me-2'
                        onClick={handleOpenUploadModal}
                        style={{ fontSize: '14px', padding: '0.25rem 0.5rem', height: '34px' }}
                      // disabled={fetchedUserAccountData?.role?.customer_access === "READ"}/
                      >
                        <div className='me-2' style={{ fontSize: '14px' }}>
                          <i className='bi bi-file-earmark-arrow-up fs-4'></i>
                        </div>
                        <div style={{ fontSize: '14px' }}>{isOmsPlatform ? 'Bulk Upload' : 'Product & Warehouse Upload'}</div>
                      </button>
                    )}

                  {isManomanoPlatform && isWrite && isUserHavingWriteAccess() && (
                    <button
                      className='btn btn-primary btn-sm d-inline-flex align-items-center me-2'
                      onClick={handleOpenErrorReportUploadModal}
                      style={{ fontSize: '14px', padding: '0.25rem 0.5rem', height: '34px' }}
                    >
                      <div className='me-2' style={{ fontSize: '14px' }}>
                        <i className='bi bi-file-earmark-arrow-up fs-4'></i>
                      </div>
                      <div style={{ fontSize: '14px' }}>Upload Error Report</div>
                    </button>
                  )}

                  {/* {fetchedUserAccountData?.role &&
              (<>
                {fetchedUserAccountData?.role?.customer_access === "READ" 
                ?                 
                (
                  <div
                    className='btn btn-primary btn-sm d-inline-flex align-items-center'
                    style={{
                      fontSize: '14px',
                      padding: '0.25rem 0.5rem',
                      opacity: 0.5,
                      cursor: 'not-allowed',
                      pointerEvents: 'none',
                    }}
                  >
                    <div className='me-2' style={{fontSize: '14px'}}>
                      <FontAwesomeIcon icon={faCog} className='svg-icon-muted svg-icon-2hx' />
                    </div>
                    <div style={{fontSize: '14px'}}>Settings</div>
                  </div>
                ) : (
                    <Link
                      to={
                        mainStore ? `/primary-platform-setting/${id}`
                          : `/channel-settings/${platformId}/${id}`}
                      className='btn btn-primary btn-sm d-inline-flex align-items-center'
                      style={{ fontSize: '14px', padding: '0.25rem 0.5rem' }}
                  >
                    <div className='me-2' style={{fontSize: '14px'}}>
                      <FontAwesomeIcon icon={faCog} className='svg-icon-muted svg-icon-2hx' />
                    </div>
                    <div style={{fontSize: '14px'}}>Settings</div>
                  </Link>
                )}
              </>
              )} */}

                  {
                    (canShowCreateAndActions && isWrite) && 
                    (
                      <button
                        className="btn btn-primary btn-sm d-inline-flex align-items-center me-2"
                        style={{ fontSize: '14px', padding: '0.25rem 0.5rem', height: '34px' }}
                        onClick={handleCreate}
                      >
                        + Add Product
                      </button>
                    )}

                  {isOmsPlatform && (isWrite && isUserHavingWriteAccess()) && (
                    <Dropdown align="end" className="d-inline-block me-2">
                      <Dropdown.Toggle
                        variant="light"
                        className="d-inline-flex align-items-center justify-content-center"
                        style={{
                          height: '34px',
                          width: '34px',
                          padding: 0,
                          backgroundColor: '#f5f8fa',
                          border: '1px solid #e4e6ef',
                          borderRadius: '6px',
                          boxShadow: 'none',
                        }}
                        bsPrefix="btn"
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="#555" aria-hidden="true">
                          <circle cx="12" cy="5" r="2" />
                          <circle cx="12" cy="12" r="2" />
                          <circle cx="12" cy="19" r="2" />
                        </svg>
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        style={{
                          fontSize: '14px',
                          minWidth: '240px',
                          padding: '8px 0',
                          borderRadius: '8px',
                          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
                        }}
                      >
                        {canShowUploadButton && (
                          <Dropdown.Item
                            onClick={handleOpenUploadModal}
                            className="d-flex align-items-center gap-2 py-2 px-3"
                          >
                            <span
                              className="d-inline-flex align-items-center justify-content-center"
                              style={{ width: 22, fontSize: '16px' }}
                              aria-hidden="true"
                            >
                              📥
                            </span>
                            <span>Bulk Import Products</span>
                          </Dropdown.Item>
                        )}
                        <Dropdown.Item
                          onClick={() => navigate('/custom-fields')}
                          className="d-flex align-items-center gap-2 py-2 px-3"
                        >
                          <span
                            className="d-inline-flex align-items-center justify-content-center"
                            style={{ width: 22, fontSize: '16px', color: '#a78bfa' }}
                            aria-hidden="true"
                          >
                            <FontAwesomeIcon icon={faCog} />
                          </span>
                          <span>Manage Custom Fields</span>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  )}

                  {!isOmsPlatform && (isWrite && isUserHavingWriteAccess()) && (
                    <Link
                      to={
                        platformId && id
                          ? `/channel-settings/${platformId}/${id}`
                          : `/platform-setting/${id}`
                      }
                      className='btn btn-primary btn-sm d-inline-flex align-items-center me-2'
                      style={{ fontSize: '14px', padding: '0.25rem 0.5rem', height: '34px' }}
                    >
                      <div className='me-2' style={{ fontSize: '14px' }}>
                        <FontAwesomeIcon icon={faCog} className='svg-icon-muted svg-icon-2hx' />
                      </div>
                      <div style={{ fontSize: '14px' }}>Settings</div>
                    </Link>
                  )}

                  {/* {(isUserHavingWriteAccess() || Boolean(localStorage.getItem(loggedInAdminAccessToken))) && (
                    <button
                      className='btn btn-primary btn-sm d-inline-flex align-items-center ms-2 me-sm-4'
                      style={{ fontSize: '14px', padding: '0.25rem 0.5rem', height: '34px' }}
                      onClick={() => {
                        setShowRefreshModal(true)
                        setRefreshPlatformId(Number(id))
                      }}
                    // disabled={fetchedUserAccountData?.role?.customer_access === "READ"}
                    >
                      <div className='me-2' style={{ fontSize: '14px' }}>
                        <FontAwesomeIcon
                          icon={faArrowsRotate}
                          className='svg-icon-muted svg-icon-2hx'
                        />
                      </div>
                      <div style={{ fontSize: '14px' }}>Refresh Data</div>
                    </button>
                  )} */}
                </div>
              </div>
            </div>
          </div>

          <div className='mb-4'>
            <div
              className='d-flex align-items-center border-bottom'
              style={{ gap: '32px' }}
            >
              <button
                type='button'
                className='btn btn-link text-decoration-none px-0'
                onClick={() => setActiveView('flat')}
                style={{
                  color: activeView === 'flat' ? '#0d6efd' : '#6c757d',
                  borderBottom:
                    activeView === 'flat' ? '2px solid #0d6efd' : '2px solid transparent',
                  borderRadius: 0,
                  fontWeight: 600,
                }}
              >All Products
                {/* (Flat) */}
              </button>
              <button
                type='button'
                className='btn btn-link text-decoration-none px-0'
                onClick={() => setActiveView('grouped-lite')}
                style={{
                  color: activeView === 'grouped-lite' ? '#0d6efd' : '#6c757d',
                  borderBottom:
                    activeView === 'grouped-lite' ? '2px solid #0d6efd' : '2px solid transparent',
                  borderRadius: 0,
                  fontWeight: 600,
                }}
              >
                Grouped View
              </button>
            </div>
          </div>

          {activeView === 'flat' ? (
            <>
              {(liteColumnsError || liteDataError) && (
                <div className="alert alert-danger d-flex align-items-center mb-4" role="alert">
                  <i className="bi bi-exclamation-triangle-fill me-3 fs-3"></i>
                  <div>
                    <strong>Error loading data:</strong>
                    <div className="mt-1">{liteColumnsError || liteDataError}</div>
                  </div>
                </div>
              )}
              <ProductTableLite
                data={liteData}
                loading={liteDataLoading}
                catalogColumns={liteCatalogColumnsWithActions}
                selectedColumns={liteSelectedColumnsWithActions}
                onColumnsChange={liteHandleColumnsChange}
                onReorderColumns={liteHandleReorderColumns}
                onPinColumn={liteHandlePinColumn}
                getColumnByField={liteGetColumnByFieldWithActions as any}
                sortState={liteSortState}
                onSortChange={liteHandleSortChange}
                filterState={liteFilterState}
                onFilterChange={liteHandleFilterChange}
                paginationState={litePaginationState}
                onPageChange={liteHandlePageChange}
                onPageSizeChange={liteHandlePageSizeChange}
                onRefresh={liteRefetch}
                onExportCSV={liteHandleExportCSV}
                onResetColumns={liteHandleResetColumns}
                onResyncClick={liteHandleResyncClick}
                onResyncSelected={liteEnableResyncSelection ? liteHandleResyncSelected : undefined}
                resyncSelectedCount={liteSelectedFailedVariantIds.length}
                resyncSelectedLoading={liteResyncingSelected}
                enableBulkActions={liteEnableBulkActions}
                selectedAction={liteSelectedAction}
                onSelectedActionChange={liteHandleBulkActionChange}
                bulkActionOptions={liteBulkActionOptions}
                selectedCount={liteSelectedItemForActions.length}
                selectionEnabled={liteEnableBulkActions || liteEnableResyncSelection || liteEnableDeleteSelection}
                selectedRowIds={liteSelectedItemForActions}
                onSelectedRowIdsChange={setLiteSelectedItemForActions}
                isRowSelectable={(liteEnableBulkActions || liteEnableDeleteSelection) ? undefined : isRowResyncEligible}
                hideSelectAllCheckbox={liteEnableDeleteSelection}
                onDeleteSelected={liteEnableDeleteSelection ? handleBulkDeleteClick : undefined}
                deleteSelectedLoading={liteIsBulkDeleting}
                platformId={platformId}
                channelId={id}
                mainStore={mainStore}
                erpStore={erpStore}
                tabsData={tabsData}
                mandatoryColumns={liteMandatoryColumns}
                defaultVisibleFields={liteDefaultVisibleFields}
                onImagePreview={setLitePreviewImageUrl}
                onOpenColumnsConfig={liteHandleOpenColumnsConfig}
                onFlatLiteEditVariant={isFlatOmsStore ? handleFlatLiteEditVariant : undefined}
                onFlatLiteDeleteVariant={isFlatOmsStore ? handleFlatLiteDeleteVariant : undefined}
                groupedLiteEditEnabled={isWrite}
                onLinkClick={(rowData) => {
                  setClickedGroupedLiteRow(rowData)
                  setClickedRowIndex(null)
                  setShowModal(true)
                  setMatchedParentProduct(null)
                  setSearchTerm('')
                  setPaginationMainData({ page: 1, limit: 10, search_string: '' })
                }}
              />

              {litePreviewImageUrl && (
                <div
                  onClick={() => setLitePreviewImageUrl(null)}
                  style={{
                    position: 'fixed',
                    inset: 0,
                    zIndex: 9999,
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '40px',
                    cursor: 'pointer',
                  }}
                >
                  <button
                    type='button'
                    onClick={() => setLitePreviewImageUrl(null)}
                    aria-label='Close preview'
                    style={{
                      position: 'absolute',
                      top: '20px',
                      right: '20px',
                      width: '36px',
                      height: '36px',
                      border: 'none',
                      borderRadius: '6px',
                      backgroundColor: 'rgba(255, 255, 255, 0.95)',
                      color: '#212529',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0,
                    }}
                  >
                    <i className='bi bi-x-lg' style={{ fontSize: '14px' }} />
                  </button>

                  <img
                    src={litePreviewImageUrl}
                    alt='Product preview'
                    onClick={(event) => event.stopPropagation()}
                    style={{
                      maxWidth: '90vw',
                      maxHeight: '90vh',
                      objectFit: 'contain',
                      borderRadius: '8px',
                      backgroundColor: '#fff',
                      padding: '8px',
                    }}
                  />
                </div>
              )}
            </>
          ) : (
            <GroupedViewLiteContainer
              key={`grouped-lite-${liteUserId || 'guest'}-${id || '0'}`}
              id={id}
              platformId={platformId}
              currentChannelData={currentChannelData}
              mainStore={mainStore}
              accountingStore={accountingStore}
              shippingStore={shippingStore}
              erpStore={erpStore}
              tabsData={tabsData}
              isOmsStore={
                canShowCreateAndActions
              }
              onGroupedLiteEditProduct={
                canShowCreateAndActions ? handleGroupedLiteEditProduct : undefined
              }
              groupedLiteEditEnabled={isWrite}
              onLinkClick={(rowData, rowIndex) => {
                setClickedGroupedLiteRow(rowData)
                setClickedRowIndex(rowIndex)
                setShowModal(true)
                setMatchedParentProduct(null)
                setSearchTerm('')
                setPaginationMainData({
                  page: 1,
                  limit: 10,
                  search_string: '',
                })
              }}
              linkingCompleted={linkingCompleted}
            />
          )}

          <div>
            <Modal size='lg' show={showModal} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Find Matching Product</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ overflowY: 'scroll', minHeight: '500px', maxHeight: '500px' }}>
                <Tabs
                  activeKey={activeTab}
                  onSelect={(k) => {
                    setActiveTab(k)
                    setPaginationMainData({
                      limit: 10,
                      page: 1,
                      search_string: '',
                    })
                  }}
                  id='product-tab'
                  className='mb-3 custom-tabs-product'
                >
                  {Array.isArray(tabsData) &&
                    tabsData?.map((tab: any) => (
                      <Tab
                        eventKey={tab.id}
                        title={
                          <div className='d-flex flex-column align-items-center'>
                            <span>{tab.display_name || tab.name}</span>
                            <span className='fs-6'>{`(${tab.type})`}</span>
                          </div>
                        }
                        key={tab.id}
                      >
                        <div>
                          <div
                            className='d-flex align-items-center mx-1 px-1'
                            style={{ backgroundColor: 'aliceblue', border: '4px inset lightgray' }}
                          >
                            <span className='symbol-label m-3' style={{ backgroundImage: 'none' }}>
                              <img
                                src={
                                  productImage
                                    ? productImage.image_url
                                    : 'https://appconnect-images.s3.us-east-2.amazonaws.com/No_Image_Available.jpg'
                                }
                                alt='Product Image'
                                style={{ width: '50px', height: '50px' }}
                              />
                            </span>
                            <div>
                              <div>
                                <h4>
                                  {platformProductName + ' - '}
                                  <span className='text-secondary'>{`${name}` == 'Default Title' ? ' ' : `${name}`}{' '}</span>
                                </h4>

                                <h5>Variant_Sku: {`${sku}`}</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='d-flex justify-content-between mx-1 mt-3'>
                          <h5 className='text-secondary d-inline align-self-center'>
                            {`Search for an existing product of ${tab.display_name || tab.name} channel to link`}
                          </h5>
                          <div style={{ position: 'relative', width: '33%', marginBottom: '10px' }}>
                            <input
                              type='text'
                              className='form-control pr-5 custom-input'
                              placeholder='Enter Product Name or Store SKU'
                              value={searchTerm}
                              onChange={(ev) => {
                                setSearchTerm(ev.target.value)
                              }}
                              onKeyDown={(ev) => {
                                if (ev.key === 'Enter') {
                                  setPaginationMainData((pre) => {
                                    return { ...pre, search_string: searchTerm }
                                  })
                                }
                              }}
                              style={{ border: '2px solid lightgray' }}
                            />
                            <FontAwesomeIcon
                              icon={faMagnifyingGlass}
                              style={{
                                position: 'absolute', right: '15px', top: '50%',
                                transform: 'translateY(-50%)', color: 'gray', pointerEvents: 'none',
                              }}
                            />
                          </div>
                        </div>
                        {productVarientsFromMainChannel.loadingProductVarientFromMainChannel ? (
                          <div className='card-body d-flex justify-content-center align-items-center'>
                            <Loader variant="section" />
                          </div>
                        ) : productVarientsFromMainChannel.productVarientFromMainChannel
                          .length === 0 ? (
                          <div className='card-body d-flex justify-content-center align-items-center'>
                            <h5>No Items Found</h5>
                          </div>) : (
                          productVarientsFromMainChannel.productVarientFromMainChannel.map(
                            (product: any, index) => (
                              <div
                                key={index}
                                className='product-item mx-1'
                                style={{ cursor: 'pointer' }}
                              >
                                <div className='border-bottom my-2 border-2'></div>

                                <div className='d-flex align-items-center justify-content-start'>
                                  <div className='m-2 me-4'>
                                    <span
                                      className='symbol-label'
                                      style={{ backgroundImage: 'none' }}
                                    >
                                      {product.platform_product &&
                                        product.platform_product.image_set.length > 0 ? (
                                        <img
                                          src={product.platform_product.image_set[0].image_url}
                                          alt={`Product Image ${index}`}
                                          style={{ width: '50px', height: '50px' }}
                                        />
                                      ) : (
                                        <img
                                          src='https://appconnect-images.s3.us-east-2.amazonaws.com/No_Image_Available.jpg'
                                          alt='No Image Available'
                                          style={{ width: '50px', height: '50px' }}
                                        />
                                      )}
                                    </span>
                                  </div>
                                  <div className='d-flex justify-content-between w-100 align-items-center'>
                                    <div className='me-4 text-start'>
                                      <div>
                                        <h4 className='mb-0'>
                                          {product?.platform_product?.name + ' -'}
                                          <span className='text-secondary'>
                                            {product?.name == 'Default Title' ? ' ' : product?.name}{' '}
                                          </span>
                                        </h4>
                                        <h5 className='text-secondary'>{product?.sku}</h5>
                                      </div>
                                    </div>
                                    {isWrite && <button
                                      className={`m-4 text-end btn btn-success btn-sm d-flex align-items-center justify-content-center `}
                                      style={{ fontSize: '10px' }}
                                      onClick={() => {
                                        // if (
                                        //   matchedParentProduct &&
                                        //   matchedParentProduct?.platform_product?.id === product?.platform_product?.id
                                        // ) {
                                        //   // If the clicked product is already selected, deselect it
                                        //   console.log('Deselecting product:', product)
                                        //   setMatchedParentProduct(null)
                                        // } else {
                                        //   // Otherwise, select the clicked product
                                        //   console.log('Selecting product:', product)
                                        // }
                                        setMatchedParentProduct(product)
                                        setOpenConnectConfirmation(true)
                                      }}
                                    >
                                      {matchedParentProduct &&
                                        matchedParentProduct?.id === product?.id ? 'Selected' : 'Select'}
                                      {matchedParentProduct &&
                                        matchedParentProduct?.platform_product?.id ===
                                        product?.platform_product?.id && (<FontAwesomeIcon icon={faArrowRight} className='ms-2' />)}
                                    </button>}
                                  </div>
                                </div>
                              </div>
                            )
                          )
                        )}
                      </Tab>
                    ))}
                </Tabs>
              </Modal.Body>

              <Modal.Footer>
                <div>
                  <strong>Showing {productRecordRange?.startRecord} - {productRecordRange?.endRecord} of{' '}
                    {productVarientsFromMainChannel.ProductVarientCountFromMainChannel} Records{' '}</strong>
                </div>
                <Button
                  onClick={() => handlePagination(paginationMainData.page - 1)}
                  disabled={productVarientsFromMainChannel.previous == null}
                >
                  <FontAwesomeIcon icon={faChevronLeft} />
                </Button>
                <Button
                  onClick={() => handlePagination(paginationMainData.page + 1)}
                  disabled={productVarientsFromMainChannel.next == null}
                >
                  <FontAwesomeIcon icon={faChevronRight} />
                </Button>
                <Button variant='secondary' onClick={handleClose}>
                  Close
                </Button>
                {/* <Button variant='primary' onClick={handleLinkProductVariant}>
            Save Changes
          </Button> */}
              </Modal.Footer>
            </Modal>

            {isOmsPlatform ? (
              <UploadCsvModal
                show={showUploadModal}
                handleClose={handleCloseUploadModal}
                platformId={platformModalId || id}
                connectedPlatformTypes={connectedPlatformTypes}
              />
            ) : (
              <CSVUploadModal
                show={showUploadModal}
                handleClose={handleCloseUploadModal}
                id={platformModalId}
                platformData={platformData}
              // handleUploadCSV={() => handleUploadCSVFile(csvFile)}
              />
            )}

            {isManomanoPlatform && (
              <ManoManoErrorReportUploadModal
                show={showErrorReportUploadModal}
                handleClose={handleCloseErrorReportUploadModal}
                platformId={platformModalId || id || ''}
                platformData={platformData}
              />
            )}

            {currentChannelData?.is_product_mapping_allowed && (
              <BulkProductLinking
                show={showBulkProductLinkingModal}
                handleClose={handleCloseBulkProductLinkingModal}
                id={platformModalId}
                platformData={platformData}
                available_map={currentChannelData?.available_map}
              // handleUploadCSV={() => handleUploadCSVFile(csvFile)}
              />
            )}

            <CommonAlertModal
              title='The Selected Product will going to be matched with this listing. Do you want to continue?'
              subtitle=''
              onSuccess={() => handleLinkProductVariant(activeTab)}
              onCancel={() => {
                setOpenConnectConfirmation(false)
                setMatchedParentProduct(null)
              }}
              cancelBtnTitle='Close'
              successBtnTitle='Yes confirm'
              isVisible={openConnectConfirmation}
              isTermsVisible={false}
              setIsVisible={() => { }}
              successDisabled={linkingCompleted}
            />
            <CommonAlertModal
              key={'reffresh data modal'}
              isVisible={showRefreshModal}
              successDisabled={refreshing}
              onCancel={() => {
                setShowRefreshModal(false)
                setRefreshPlatformId(null)
              }}
              onSuccess={() => {
                if (refreshPlatformId) {
                  setRefreshing(true)
                  dispatch(refreshPlatformDataAsync({ platformId: refreshPlatformId })).then(
                    (response) => {
                      successToast(
                        response.payload?.data?.message
                          ? response.payload?.data?.message : JSON.stringify(response.payload?.data?.message))
                      setRefreshing(false)
                      setRefreshPlatformId(null)
                      setShowRefreshModal(false)
                    }
                  )
                }
              }}
              title='Are you sure ?'
              subtitle='This might take 10-15 minutes to complete'
              isTermsVisible={false}
            />

            <CommonAlertModal
              title={`Are you sure you want to delete this variant?`}
              subtitle='This variant will be deleted permanently.'
              isVisible={liteShowDeleteVariantModal}
              isTermsVisible={false}
              onSuccess={handleDeleteVariantConfirm}
              onCancel={() => {
                if (liteIsDeletingVariant) return
                setLiteShowDeleteVariantModal(false)
                setLiteSelectedVariantToDelete(null)
              }}
              successBtnTitle={liteIsDeletingVariant ? 'Deleting...' : 'Yes, Delete'}
              cancelBtnTitle='Cancel'
              successBtnClasses='btn btn-sm btn-danger m-2'
              successDisabled={liteIsDeletingVariant}
            />

            <CommonAlertModal
              title={`Delete ${liteSelectedItemForActions.length} selected variant${liteSelectedItemForActions.length === 1 ? '' : 's'}?`}
              subtitle='These variants will be permanently deleted and cannot be recovered.'
              isVisible={liteShowBulkDeleteModal}
              isTermsVisible={false}
              onSuccess={handleBulkDeleteConfirm}
              onCancel={() => {
                if (liteIsBulkDeleting) return
                setLiteShowBulkDeleteModal(false)
              }}
              successBtnTitle={liteIsBulkDeleting ? 'Deleting...' : `Yes, Delete ${liteSelectedItemForActions.length}`}
              cancelBtnTitle='Cancel'
              successBtnClasses='btn btn-sm btn-danger m-2'
              successDisabled={liteIsBulkDeleting}
            />

            <CommonAlertModal
              key={'delist confirmation modal'}
              title={`Are You Sure You Want to ${liteSelectedAction === 'full_update'
                ? 'Fully Update All Products' : 'Update the Selected Products'}?`}
              subtitle=''
              successBtnTitle={liteIsDelistIng ? 'Delisting...' : 'Yes Confirm'}
              isTermsVisible={false}
              isVisible={liteOpnDelistModal}
              onSuccess={() => {
                if (!id || !liteSelectedAction || !liteAllowedBulkActions.has(liteSelectedAction)) {
                  return
                }
                setLiteIsDelistIng(true)
                dispatch(
                  delistVariantsAsync({
                    platform_id: Number(id),
                    delist_variant_ids: liteSelectedItemForActions.map((v) => Number(v)),
                    type: liteSelectedAction,
                  })
                )
                  .then((response: any) => {
                    const capitalize = (str: string) =>
                      str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
                    const platform = capitalize(currentChannelData?.self_data?.name || 'platform')
                    const bulkActionErrorFallback =
                      'Failed to update product listing status. Please try again.'

                    if (isApiPayloadSuccess(response)) {
                      if (response?.payload?.message) {
                        successToast(
                          `Your request has been successfully submitted to ${platform}. Updates will reflect on ${platform}'s platform once their API processes the request, which can take 15-20 minutes or longer. If you don't see the status change by then, please don't hesitate to contact our support team.`
                        )
                      }
                    } else {
                      errorToast(getApiErrorMessage(response, bulkActionErrorFallback))
                    }
                    setLiteSelectedAction('')
                    setLiteOpnDelistModal(false)
                    setLiteSelectedItemForActions([])
                    setLiteIsDelistIng(false)
                    liteRefetch()
                  })
                  .catch((error) => {
                    errorToast(
                      getApiErrorMessage(
                        error,
                        'Failed to update product listing status. Please try again.'
                      )
                    )
                    setLiteIsDelistIng(false)
                  })
              }}
              onCancel={() => {
                setLiteOpnDelistModal(false)
                setLiteSelectedAction('')
              }}
            />

          </div>
        </>
      )}
    </>
  )
}

export default ProductsTable

